import AcceptedMaterials from "@/views/permits/CCDD/AcceptedMaterials.vue";
import DailyOperations from "@/views/permits/CCDD/DailyOperations.vue";
import CCDDViolations from "@/views/permits/CCDD/Violations.vue";

export default {
    AcceptedMaterials,
    DailyOperations,
    CCDDViolations
}